import router from "@/router";
import {calcCols} from "@/features/wishlist/WishListHelpers";

const state = {
	allProducts: [],
	config: {}
}

const getters = {
	userId(){
		return  router.currentRoute.query.userId || router.currentRoute.query.custId;
	},
	userFirstName(){
		return router.currentRoute.query.ufname || '';
	},
	prodCodes() {
		const prods = router.currentRoute.query.products;
		return prods?.split(',');
	},
	cols(state, getters) {
		const pc = getters.products.length;
		return calcCols(pc);// pc % 2 === 0 ?  (pc / 2) + 1 : (pc + 1) / 2;
	},
	colMode(state, getters) {
		return getters.products.length % 2 === 0 ? 'even' : 'odd';
	},
	products(state, getters, rootState, rootGetters) {
		if(rootGetters['config/features']?.wishlist?.noCheck){
			return state.allProducts;
		}
		const prods = rootGetters['productsBySKU'];
		return state.allProducts.filter(p => prods[p.code]);
	}
}

const actions = {

	setConfig({commit}, config) {
		commit('setConfig', config);
	},
	setProducts({commit}, products) {
		commit('setProducts', products);
	}
}

const mutations = {
	setProducts(state, products) {
		state.allProducts = products;
	},
	setConfig(state, config) {
		state.config = config;
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
